export default __webpack_public_path__ + "static/media/BrutalType-Bold.2792a94a.svg";